import css from '../assets/css.png';
import figma from '../assets/figma.png';
import git from '../assets/git.png';
import html from '../assets/html.png';
import javascript from '../assets/javascript.png';
import nextjs from '../assets/nextjs.png';
import typescript from '../assets/typescript.png';
import node from '../assets/node.png';
import react from '../assets/react.png';
import sass from '../assets/sass.png';
import mongodb from '../assets/mongo.svg';
import redux from '../assets/redux.png';
import photoshop from '../assets/photoshop.png';
import html5 from '../assets/html5.png';
import circle from '../assets/circle.svg';
import logo from '../assets/logo.png';
import juusoprofilephoto from '../assets/juusoprofilephoto.png';





export default {
  html5,
  css,
  figma,
  git,
  html,
  javascript,
  typescript,
  node,
  react,
  redux,
  sass,
  juusoprofilephoto,
  circle,
  logo,
  photoshop,
  mongodb,
  nextjs
};